const interpolate = (start, end, t) => start * (1 - t) + end * t;

export const returnChartColors = (baseColor1, baseColor2, paletteNumber) => {
  const colors = [];

  for (let i = 0; i < paletteNumber; i++) {
    const t = i / (paletteNumber - 1);
    const r = Math.round(interpolate(baseColor1.r, baseColor2.r, t));
    const g = Math.round(interpolate(baseColor1.g, baseColor2.g, t));
    const b = Math.round(interpolate(baseColor1.b, baseColor2.b, t));
    colors.push(`rgb(${r}, ${g}, ${b})`);
  }

  return paletteNumber <= 5
    ? ['#3C9AE8', '#7b94c8', '#b686ab', '#d97578', '#f0624a']
    : colors;
};
